export default {
  type: '',
  statement: '',
  owner: {
    address: { city: '', state: 'UT', street: '', zip: '' },
    email: '',
    name: '',
    primaryPhone: '',
    secondaryPhone: '',
  },
  info: {
    accountNo: '',
    serialNumber: '',
    type: '',
    vin: '',
    address: {
      street: '',
      city: '',
      state: 'UT',
      zip: '',
    },
  },
  valueAndTaxInfo: {
    amountToBeRefunded: '',
    amountOfferedInSettlement: '',
    amountPaid: '',
    currMarketValue: '',
    assets: [],
  },
  valuation: [],
  personal: [],
  other: [],
};
